import { Exception } from '../Exception';

export class ApiException extends Exception {
  constructor(message: string) {
    super(message);
  }
}
